import Insight from "../insightClass";
import React from "react";
import { insight112Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight112 = new Insight(
  "11 May 2026",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight112Media[0],
    alt: "offshore wind farm",
  },
  "Global Offshore Wind Weekly (2026-05-11)",
  "",
  `Rising geopolitical tension in the Middle East appears to be strengthening the case for clean energy investment, as governments and energy companies reassess the role of renewables in energy security. Wind industry majors Vestas and Ørsted both beat market expectations in the first quarter of 2026. Ørsted cited the Iran war as one of the reasons to continue pushing ahead with clean technology investment, underlining how renewables are increasingly being framed not only as decarbonisation tools, but also as assets that can improve supply resilience.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2026-05-11)</h1>
    <h2></h2>
    <p className="article-date">11 May 2026</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>
      1. Iran war sharpens energy security debate as wind companies beat
      first-quarter expectations
    </h3>
    <p>
      Rising geopolitical tension in the Middle East appears to be strengthening
      the case for clean energy investment, as governments and energy companies
      reassess the role of renewables in energy security. Wind industry majors
      Vestas and Ørsted both beat market expectations in the first quarter of
      2026. Ørsted cited the Iran war as one of the reasons to continue pushing
      ahead with clean technology investment, underlining how renewables are
      increasingly being framed not only as decarbonisation tools, but also as
      assets that can improve supply resilience.
    </p>
    <p>
      Vestas reported a stronger-than-expected rise in first-quarter profit,
      supported by improved execution across both its onshore and offshore
      businesses, despite ongoing political uncertainty. Norway’s Equinor, still
      primarily an oil and gas major, also delivered strong earnings for the
      first three months of the year. Its chief financial officer said the
      Middle East crisis is expected to support the company’s transition
      industries, suggesting that even conventional energy companies see
      low-carbon investment gaining strategic relevance in a more volatile
      energy landscape.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The significance of this story lies not only in the profit beats, but in
      the changing narrative around the energy transition. Offshore wind and
      wider renewables have often been discussed through the lens of climate
      targets, subsidies and project economics. In the current geopolitical
      environment, their value is being reframed around energy independence,
      domestic generation and resilience against fossil fuel supply shocks.
    </p>
    <p>
      However, stronger sentiment does not remove the structural challenges
      facing the wind sector. Developers and manufacturers still face supply
      chain pressure, grid constraints, financing costs, permitting delays and
      policy uncertainty. The improved performance from Vestas and Ørsted
      suggests execution is stabilising, but a sustained sector recovery will
      depend on higher-quality order books, realistic auction pricing, lower
      capital cost pressure and clearer government support. For investors and
      suppliers, the key question is whether the renewed energy security
      argument will translate into bankable policy frameworks and faster project
      delivery.
    </p>
    <h3>2. UK trials wind turbines powered by high-speed train airflow</h3>
    <p>
      UK rail operator LNER has installed three experimental wind turbines
      beside the East Coast Main Line at Hitachi Rail’s Craigentinny depot in
      Edinburgh, aiming to capture the turbulent airflow created by passing
      high-speed trains and convert it into electricity. It is the first trial
      of this kind next to a UK main line. The project is being delivered with
      clean energy infrastructure company Treeva, with support from Hitachi Rail
      and Network Rail.
    </p>
    <p>
      The six-foot-tall turbines are made from upcycled materials, require no
      grid connection, and can be deployed on underused railway land close to
      the tracks. Over a six-month trial, the electricity generated will be
      captured, measured and used to power rail-side devices. LNER said one
      turbine could power one third of a small station’s lighting needs, four
      CCTV cameras, or two passenger information screens, while five turbines
      could reduce emissions by more than 12,000 kilograms of CO2 per year,
      equivalent to planting 500 trees.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This is a small trial, but it is a useful example of distributed clean
      energy being tailored to transport infrastructure. Rather than competing
      with utility-scale wind or solar, the technology targets local, low-power
      demand, using energy that would otherwise be wasted from train movement.
    </p>
    <p>
      The key commercial test will be whether the turbines can operate safely
      and reliably in a demanding rail environment. If the six-month trial shows
      stable output, low maintenance needs and a clear payback case, this type
      of modular wind solution could become a practical add-on for railway
      decarbonisation and wider infrastructure energy optimisation.
    </p>
    <h3>
      3. Record-breaking 80-metre blades arrive at Scotland’s Mill Rig Wind Farm
    </h3>
    <p>
      Record-breaking 80-metre turbine blades have arrived at Mill Rig Wind Farm
      in South Lanarkshire, Scotland. The 33.4MW project, developed by OnPath
      Energy, is expected to become fully operational by the end of the summer.
      Once completed, the six-turbine wind farm is expected to generate enough
      electricity to power around 45,000 homes each year and cut carbon
      emissions by approximately 27,000 tonnes annually.
    </p>
    <p>
      The blades are being transported to site overnight as part of a complex
      logistics operation involving specialist haulage teams, contractors and
      local authorities. The turbines will reach tip heights of nearly 200
      metres, with blades sweeping 50% more area than those used at the nearby
      Kype Muir Extension. Combined with higher rated power, this is expected to
      deliver around one third more energy output. Nordex said the project will
      feature the first N163/5.X turbines to be installed in the UK.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Although Mill Rig is an onshore wind project, it highlights an important
      direction in the UK wind market: using larger blades, taller structures
      and higher-rated machines to generate more electricity from fewer
      turbines. This is particularly relevant for onshore wind, where planning,
      land use, visual impact and community acceptance remain key constraints.
      Higher-yield turbines can improve project economics while limiting the
      number of physical units required on site.
    </p>
    <p>
      The project also shows how turbine innovation is increasing demands on
      logistics, construction and supply chain coordination. An 80-metre blade
      requires careful route planning, night-time delivery, specialist
      transport, advanced lifting operations and strong quality control. For the
      UK to meet Scotland’s ambition of 20GW of onshore wind by 2030, technology
      improvements must be matched by faster planning, stronger grid capacity,
      local supply chain readiness and credible community benefit structures.
    </p>
    <h3>
      4. France’s EFGL floating offshore wind farm starts delivering electricity
    </h3>
    <p>
      The 30MW Éoliennes Flottantes du Golfe du Lion（EFGL）floating offshore
      wind farm in France has started delivering electricity to the grid,
      marking an important step for the country’s floating wind sector.
      Developed by Ocean Winds, the project is expected to generate around
      110,000MWh of clean electricity per year and supply the equivalent annual
      demand of approximately 50,000 inhabitants over a 20-year operating
      period. As a Mediterranean floating wind demonstrator, EFGL helps validate
      floating foundations, offshore construction methods, grid connection and
      early operating performance.
    </p>
    <p>
      The project’s move into power generation is significant because floating
      offshore wind is now shifting from technology demonstration towards real
      operational data. For France, deeper southern waters offer strong offshore
      wind potential, but not all sites are suitable for fixed-bottom
      foundations. Floating technology therefore plays a central role in
      expanding the country’s offshore wind resource base and building a future
      pipeline of deep-water projects.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      EFGL’s first power is an important milestone for European floating wind.
      The value of a floating pilot is not only its capacity, but whether it can
      prove platform stability, dynamic cable reliability, operations strategy
      and financing assumptions in real conditions. For a technology segment
      that still faces high costs, operational data will directly influence
      future auction pricing, investor confidence and supply chain scale-up.
    </p>
    <p>
      From a market perspective, France is using pilot projects to prepare for
      larger commercial floating wind deployment. However, scaling floating wind
      across Europe will require clearer auction frameworks, stronger port and
      assembly capacity, and more standardised designs. EFGL helps reduce
      technical uncertainty, but the next challenge is to move floating wind
      from “technically feasible” to “financeable, repeatable and scalable”.
    </p>
    <h3>
      5. Geotechnical survey to begin at the UK’s Awel y Môr offshore wind
      project
    </h3>
    <p>
      Geotechnical survey work is scheduled to begin at the Awel y Môr offshore
      wind farm site in the UK on 12 May 2026, with activities expected to
      continue until 15 June, subject to weather and sea conditions. The
      campaign will use the vessel Connector and include cone penetration tests,
      seismic CPT and vibrocoring. The objective is to collect seabed data
      needed for foundation design, construction planning and risk management.
    </p>
    <p>
      Awel y Môr is one of the key projects in the UK offshore wind pipeline.
      The project has received development consent and is expected to include up
      to 50 turbines. RWE has also secured support for the project through the
      UK Contracts for Difference mechanism. The start of geotechnical work
      shows that the project is moving further into pre-construction
      preparation, but also underlines how major offshore wind projects still
      depend on detailed site investigation before they can move towards final
      investment and construction.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Geotechnical surveys rarely attract wide attention, but they are critical
      to offshore wind project delivery. Seabed conditions directly influence
      foundation choice, installation method, construction windows, cost
      estimates and insurance risk. For a project such as Awel y Môr,
      high-quality early-stage geological data can reduce the likelihood of
      later design changes and cost overruns.
    </p>
    <p>
      From a UK market perspective, the progress is encouraging. The UK offshore
      wind sector continues to face grid constraints, financing pressure, supply
      chain tightness and questions around auction pricing. Moving into
      geotechnical survey does not guarantee construction, but it is an
      important indicator of project maturity. For investors and contractors,
      this kind of pre-construction activity is a useful signal that the project
      is still advancing through the development pathway.
    </p>
    <h3>6. US pension fund challenges TotalEnergies over offshore wind exit</h3>
    <p>
      The New York State Common Retirement Fund is reassessing its approximately
      USD 1.6 million investment in TotalEnergies after the company decided to
      exit US offshore wind projects and accept a government payment to redirect
      investment towards oil and gas. The fund raised concerns over
      TotalEnergies’ energy transition commitments, strategic consistency,
      reputational risk and regulatory exposure, and has asked the company for
      greater transparency around the decision.
    </p>
    <p>
      The case shows how uncertainty in US offshore wind policy is now feeding
      into capital markets and corporate governance. Previously, the main
      challenges for US offshore wind centred on permitting, rising costs,
      supply chain constraints and political opposition. Now, institutional
      investors are also questioning whether energy companies can maintain
      credible long-term transition strategies when political conditions change.
      For European energy companies with exposure to the US, short-term
      portfolio adjustments may carry wider reputational and investor-relations
      consequences.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The importance of this story goes beyond TotalEnergies’ withdrawal from
      individual projects. US offshore wind is becoming a test case for the
      interaction between energy policy, corporate strategy and institutional
      investor oversight. If companies rapidly shift away from low-carbon
      commitments in response to political change, investors are likely to ask
      whether their transition strategies are credible and whether management
      has adequately considered the risk of future policy reversal.
    </p>
    <p>
      For the US offshore wind market, the central issue remains policy
      continuity. Offshore wind projects have long development cycles and
      require large upfront capital commitments. Developers need stable
      permitting, clear support mechanisms and predictable regulation. If policy
      direction changes frequently, capital will demand a higher risk premium,
      even where resource quality and electricity demand remain strong. For
      European energy companies, the US market may still offer long-term
      potential, but investment decisions will increasingly need to account for
      political risk, contractual protection and capital discipline.
    </p>
    <h3>
      7. China Three Gorges installs 16MW floating offshore wind platform off
      Yangjiang
    </h3>
    <p>
      China Three Gorges Corporation has completed installation of the Sanxia
      Linghang, or Three Gorges Pilot, a 16MW floating offshore wind platform
      off Yangjiang, Guangdong. The platform, described as the world’s largest
      single-unit floating wind platform, was installed on 2 May in waters more
      than 70 kilometres from shore and at depths exceeding 50 metres. It
      combines a 16MW turbine, a semi-submersible floating foundation and a new
      mooring system.
    </p>
    <p>
      The platform measures around 80.8 metres in length and 91 metres in width,
      with a displacement of 24,100 tonnes. The turbine has a 252-metre rotor
      diameter, a swept area equivalent to around seven football fields, and a
      blade tip height of more than 270 metres. It is designed for harsh
      offshore conditions, including wave heights above 20 metres and wind
      speeds of up to 73 m/s. The project also includes a novel mooring system,
      active ballast system, smart monitoring system and 66kV dynamic subsea
      cable. Once operational, the turbine is expected to generate around
      44.65GWh of electricity annually, enough to supply about 24,000
      households.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The significance of this project lies in China’s move from floating wind
      demonstration towards larger-capacity, deep-water system integration. A
      16MW floating unit is not only about turbine size; it also tests the
      maturity of the floating foundation, mooring design, dynamic cable,
      installation vessel capability and monitoring systems. For deep-sea
      offshore wind, the real challenge is whether the full platform can remain
      stable, safe and maintainable under demanding marine conditions.
    </p>
    <p>
      From a global market perspective, China’s rapid progress in floating wind
      could reshape technology and supply chain competition. Yangjiang has
      already become a key testing ground for large floating prototypes,
      including platforms from Mingyang and CRRC. If the Three Gorges Pilot
      delivers reliable operating data, its importance will go beyond a
      single-unit record. It could become a stronger reference case for China’s
      future commercial floating wind projects, particularly in cost reduction,
      localisation, large-scale manufacturing and offshore installation
      efficiency. For European developers and suppliers, China’s pace of
      floating wind iteration is becoming increasingly important to monitor.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
